import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 56px auto;
  }
`;

export const Wrapper = styled.div`
  &.faq-popular-questions {
    width: 100%;
    max-width: 850px;
    margin: 0 auto;
    > p {
      font-size: 18px;
      line-height: 1.22;
      letter-spacing: normal;
    }
  }

  &.related-questions {
    margin-top: 50px;
    font-size: 18px;
    > p {
      font-size: 18px;
      line-height: 1.22;
      letter-spacing: normal;
    }
  }

  &.related-faqs {
    padding: 80px 0 56px;
    width: 100%;
    max-width: 850px;
    margin: 0 auto;
    > p {
      font-size: 18px;
      line-height: 1.22;
      letter-spacing: normal;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &.faq-popular-questions,
    &.related-questions,
    &.related-faqs {
      > p {
        font-size: 20px;
        line-height: 1.2;
      }
    }

    &.related-faqs {
      padding: 80px 0 25px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    &.faq-popular-questions,
    &.related-questions,
    &.related-faqs {
      > p {
        font-size: 24px;
        line-height: 1.33;
      }
    }
  }
`;

export const Heading = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;

  p {
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 1.25;
    font-weight: ${themeGet('fontWeights.bold')};

    b,
    strong {
      font-weight: ${themeGet('fontWeights.medium')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    p {
      font-size: 20px;
      line-height: 1.14;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    p {
      font-size: 2.5rem;
      line-height: 130%;
      letter-spacing: -0.25px;
    }
  }

  ${Wrapper}.related-faqs & {
    p {
      b,
      strong {
        font-weight: ${themeGet('fontWeights.medium')};
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      p {
        font-size: 2rem;
        line-height: 1.14;
      }
    }
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      p {
        font-size: 2.5rem;
        line-height: 1.14;
      }
    }
  }
`;

export const Questions = styled.ul`
  li:not(:first-child) {
    margin-top: 0;
  }

  li {
    padding: 10px 20px 10px 0;
    border-bottom: 1px solid ${themeGet('colors.light-border-grey')};
    ${Wrapper}.related-faqs & {
      border-bottom: 1px solid ${themeGet('colors.border-grey')};
    }
    position: relative;
    display: flex;
    justify-content: space-between;
  }

  a {
    color: ${themeGet('colors.main-text')};
    font-weight: ${themeGet('fontWeights.medium')};
    font-size: 0.875rem;
    line-height: 1.5;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 1.125rem;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    li {
      padding: 20px 25px 20px 0;
    }
  }

  ${Wrapper}.faq-popular-questions & {
    a {
      &:hover,
      &:focus {
        color: ${themeGet('colors.pc-red', '#E1251B')};
      }
    }
  }

  ${Wrapper}.related-questions & {
    li {
      border-bottom: none;
    }

    a {
      &:hover,
      &:focus {
        color: ${themeGet('colors.pc-red', '#E1251B')};
      }
    }
  }

  ${Wrapper}.related-faqs & {
    a {
      &:hover,
      &:focus {
        color: ${themeGet('colors.pc-red', '#E1251B')};
      }
    }
  }
`;

export const Ctas = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 25px;

  a {
    margin: 0.5rem 1rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 50px;
  }
`;
